// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#inbox-navigator[data-v-d67d36dc]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:13px 15px}", ""]);
// Exports
module.exports = exports;
